import { tns } from 'tiny-slider/src/tiny-slider';

const controls = (() => {
    const div = document.createElement('div');

    div.innerHTML = `<div class="c-controls">
        <button class="c-prev" aria-label="c-prev"></button>
        <button class="c-next" aria-label="c-next"></button>
    </div>`;

    return div.firstChild;
})();

const options = {
    autoplay: true,
    autoplayButtonOutput: false,
    autoplayTimeout: 8000,
    controls: true,
    edgePadding: 0,
    gutter: 25,
    items: 1,
    loop: true,
    mouseDrag: true,
    nav: false,
    preventScrollOnTouch: 'auto',
    slideBy: 1,
    speed: 600,
    swipeAngle: 30,
    responsive: {
        992: {
            edgePadding: 15,
            gutter: 25,
        },
    },
};

function init() {
    const elements = document.querySelectorAll('[data-slider="inverse-box"]');

    [...elements].forEach((element) => {
        element.appendChild(controls.cloneNode(true));

        tns({
            ...options,
            container: element.querySelector('.swiper-wrapper'),
            controlsContainer: element.querySelector('.c-controls'),
        });
    });
}

export default {
    init,
};
